export default "__VITE_ASSET__D2EI0$8Z__"